import React, { useEffect, useRef, useState } from 'react';
import DraggableUploadCard from '../FileUpload/DraggableUploadCard';
import {
  AbsoluteCenter,
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Text,
  VStack,
} from '@chakra-ui/react';
import UploadedFileCard from '../FileUpload/UploadedFileCard';
import Response from './Response';
import { useSocket } from '../../Context/SocketContext';
import uuid from 'short-uuid';
import { MdArrowUpward } from 'react-icons/md';

import { Body as ProgressPageBody } from '../Progress/ProgressPage';
import { useAuth } from '../../Context/AuthContext';

const Body = () => {
  const [file, setFile] = useState([]);
  const [response, setResponse] = useState('');
  const [fileURLs, setFileURLs] = useState([]);
  const [processingFile, setProcessingFile] = useState(false);
  const [selectedButtonID, setSelectedButtonID] = useState('');

  const [inputText, setInputText] = useState('');

  const socket = useSocket();
  const { setTopLevelError, handleConfirmationModal } = useAuth();

  const handleDropDownChange = uploadedFiles => {
    uploadedFiles.map(file => (file.id = uuid.generate()));
    uploadedFiles.forEach((file, index) => handleFileUpload(file));

    setFile(prev => [...prev, ...uploadedFiles]);
    return;
  };

  const handleDelete = id => {
    setFile(prev => prev.filter(file => file.id !== id));
    setFileURLs(prev => prev.filter(file => file.id !== id));
  };

  const handleResponse = response => {
    setFile([]);
    setResponse(response);
  };

  const handleFileAction = (id, action) => {
    // Perform the action here

    if (action === 'delete') {
      setFile(prev => prev.filter(file => file.id !== id));
      setFileURLs(prev => prev.filter(file => file.id !== id));
    } else if (action === 'retry') {
      const fileRef = file.find(file => file.id === id);
      setFile(prev =>
        prev.map(file => {
          if (file.id === id) {
            file.progress = 0;
            file.error = undefined;
          }
          return file;
        })
      );
      handleFileUpload(fileRef);
    } else if (action === 'cancel') {
      // Cancel the upload

      setFile(prev =>
        prev.map(file => {
          if (file.id === id) {
            file.progress = 0;
            file.error = true;
          }
          return file;
        })
      );
    }
  };

  const handleFileUpload = uploadedFile => {
    const chunkSize = 5 * 1024 * 1024; // 5MB
    const fileSize = uploadedFile.size;
    const fileName = uploadedFile.name;
    const fileType = uploadedFile.type;
    const id = uploadedFile.id;

    let offset = 0;
    let chunkIndex = 0;

    const reader = new FileReader();

    reader.onload = () => {
      const chunk = reader.result;
      socket.emit('uploadChunk', {
        data: chunk,
        chunkIndex,
        fileName,
        fileSize,
        offset,
        isFinalChunk: offset + chunk.byteLength >= fileSize,
        fileType,
        id,
        // courseName: selectedCourse,
      });

      offset += chunk.byteLength;
      chunkIndex++;

      if (offset < fileSize) {
        readNextChunk();
      }
    };

    const readNextChunk = () => {
      const slice = uploadedFile.slice(offset, offset + chunkSize);
      reader.readAsArrayBuffer(slice); // Use readAsArrayBuffer to read binary data
    };

    readNextChunk();
  };

  const handleSubmit = (e, explain) => {
    if (!socket) return;

    setProcessingFile(true);
    const id = e.target.id;

    setSelectedButtonID(id);
    const payload = {};
    if (id === 'text-submit-button') {
 
      const question = inputText.trim();
      if (!question) {
        setProcessingFile(false);
        return;
      }
      payload.type = 'text';
      payload.data = question;
    } else if (id === 'solve-button') {
      if (fileURLs.length === 0) {
        // something is fishy
        setProcessingFile(false);
        return;
      }
      payload.type = 'file';
      payload.data = fileURLs;
    }

    // const dummyFileURL = [
    //   {
    //     name: 'QuestionHOMEWORKHELP.pdf',
    //     url: [
    //       'https://storage.googleapis.com/studywise-e9542.appspot.com/users/wVDw370gRpggaeI0goYiWVajI0k1/uploads/studychat/sCwYPw31MSPwTHYiqM2FSy-QuestionHOMEWORKHELP.pdf?GoogleAccessId=firebase-adminsdk-9b4tz%40studywise-e9542.iam.gserviceaccount.com&Expires=32503660200&Signature=hRYp2aFpyflbLt6yzvUmO%2FphKJ4ajPbvx%2B8ggCPTqMXIEEE2gof6XujjTRLxKMvSiOWcskbcVkrCG4qsGB9xfmG6XdGwEyTEC5ylfSW8Neae4ZEcLGWR0X23OnVfF2ccpJzvV3IHddxQkBpfnT4WgGAOtPYNc2gxIiJRK45k1HC%2B0CckHAc4%2BjGP9JVWcwRZ%2BU44BSPybl%2BIuLGdz1LjylHj4me%2BcwbXm24K9t2zqn0g1fZgV5l%2BN5WgODVF2B1NxL3B6cv9iD%2FWx3B%2Br1yRXbHNPbx2hd1EzboavQh2nH4Mm6eyms7%2FklD0j5V7TOBzA3mZphkQpNZqL4GDqr6DAw%3D%3D',
    //     ],
    //     type: 'application/pdf',
    //     id: 'sCwYPw31MSPwTHYiqM2FSy',
    //   },
    // ];

    // payload.type = 'file';
    // payload.data = dummyFileURL;

    socket.emit('solveHomework', {
      ...payload,
      furtherExplainationNeeded: explain ?? false,
    });
  };

  useEffect(() => {
    if (!socket) return;

    socket.on('chunkUploadStatus', data => {
      const { success, fileName, id, progress, isFinalChunk, downloadURL } =
        data;

      setFile(prev => {
        const updatedFiles = prev.map(file => {
          if (file.id === id && !file.error) {
            if (success) {
              file.progress = progress;
              if (isFinalChunk) {
                file.downloadURL = downloadURL;

                setFileURLs(prev => [
                  ...prev,
                  {
                    name: fileName,
                    url: downloadURL,
                    type: file.type,
                    id: id,
                  },
                ]);

                // setFileURLs(prev => [...prev, downloadURL]);
                file.error = false;
              }
            } else {
              file.progress = 0;
              file.error = true;
            }
          }
          return file;
        });

        return updatedFiles;
      });
    });

    socket.on('solveHomework', data => {
      setProcessingFile(false);
      const { success, answer, creditLimitReach, furtherExplainationNeeded } =
        data;

      if (success) {
        if (!furtherExplainationNeeded) {
          setResponse(answer);
        } else {
          setResponse(prev => ({ ...prev, stepbystep: answer.explanation }));
        }
      } else {
        if (creditLimitReach) {
          setTopLevelError(
            'You have reached your credit limit. Please subscribe to continue using this feature'
          );
        } else {
          setTopLevelError(
            'Something went wrong! Please refresh and try again'
          );
        }
      }

      socket.emit('retrieveCreditPoints');

      return;
    });

    return () => {
      socket.off('chunkUploadStatus');
      socket.off('solveHomework');
    };
  }, [socket, setTopLevelError]);

  return (
    <div>
      <Box>
        {response || processingFile ? (
          <>
            {processingFile ? (
              <ProgressPageBody
                constantText="Solving your Question"
                dynamicText={[
                  'Analyzing homework upload',
                  'Breaking down the information',
                  'Consulting with the homework wizards',
                  'Double-checking solution',
                  'Just a moment...',
                ]}
              />
            ) : (
              <Response
                response={response}
                btnID={selectedButtonID}
                // handleElaborate={handleSubmit}
                handleElaborate={e =>
                  handleConfirmationModal(() => handleSubmit(e), 1)
                }
                handleResponse={handleResponse}
                resetTextBox={() => setInputText('')}
              />
            )}
          </>
        ) : (
          <>
            {/* file.length === 0  */}
            {file.length === 0 ? (
              <>
                <DraggableUploadCard
                  handleChange={handleDropDownChange}
                  multiple={false}
                />
                <Box position="relative" padding="10">
                  <Divider variant="dashed" />
                  <AbsoluteCenter bg="white" px="4">
                    OR
                  </AbsoluteCenter>
                </Box>
                <Flex justifyContent="center">
                  <InputGroup size="md" maxWidth="700px">
                    <Input
                      // ref={inputRef}
                      placeholder="Type your question here"
                      value={inputText}
                      onChange={e => setInputText(e.target.value)}
                      // onKeyDown={handleKeyDown}
                      // isDisabled={!isEnabled}
                    />
                    <InputRightElement
                      width="4.5rem"
                      id="text-submit-button"
                      onClick={e =>
                        handleConfirmationModal(() => handleSubmit(e), 1)
                      }
                      //onClick={handleSubmit}
                    >
                      <Button
                        h="1.75rem"
                        size="sm"
                        // onClick={handleClick}
                        // isDisabled={!isEnabled}
                        id="text-submit-button"
                        // onClick={handleSubmit}
                      >
                        <Icon
                          as={MdArrowUpward}
                          id="text-submit-button"
                          // onClick={handleSubmit}
                        />
                      </Button>
                    </InputRightElement>
                  </InputGroup>
                </Flex>
              </>
            ) : (
              <Flex
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  maxW="400px"
                  width="100%"
                  border="1px solid #5B35FF"
                  padding="12px"
                  borderRadius="10px"
                >
                  <Text>Uploaded Material</Text>
                  <Divider mb="5px" />
                  <VStack justifyContent="center" spacing={2}>
                    <UploadedFileCard
                      fileObj={file[0]}
                      progress={file[0]?.progress ?? 0}
                      handleAction={handleFileAction}
                      handleDelete={handleDelete}
                    />
                  </VStack>
                </Box>
                <Button
                  mt="0.9rem"
                  p="0 3rem"
                  maxW="140px"
                  id="solve-button"
                  // onClick={handleSubmit}
                  onClick={e =>
                    handleConfirmationModal(() => handleSubmit(e), 1)
                  }
                >
                  Solve
                </Button>
              </Flex>
            )}
          </>
        )}
      </Box>
    </div>
  );
};

export default Body;
